"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBlock = void 0;
require("./form-block.scss");
var Block_1 = require("modules/Block");
var Initializer_1 = require("modules/Initializer");
var utm_1 = __importDefault(require("modules/utm"));
var FormSelect_hbs_1 = __importDefault(require("./FormSelect.hbs"));
var FormBlock = (function (_super) {
    __extends(FormBlock, _super);
    function FormBlock() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.addUTMValuesToHiddenInputs = function (utmParams) {
            var e_1, _a;
            var _loop_1 = function (kvp) {
                var name_1 = kvp[0];
                var value = kvp[1];
                var hiddenInputs = _this.rootElement.querySelectorAll("input[type=\"hidden\"][value=\"".concat(name_1, "\"]"));
                hiddenInputs.forEach(function (input) {
                    input.value = value;
                });
            };
            try {
                for (var utmParams_1 = __values(utmParams), utmParams_1_1 = utmParams_1.next(); !utmParams_1_1.done; utmParams_1_1 = utmParams_1.next()) {
                    var kvp = utmParams_1_1.value;
                    _loop_1(kvp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (utmParams_1_1 && !utmParams_1_1.done && (_a = utmParams_1.return)) _a.call(utmParams_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        _this.copyMarketoSourceCampaign = function () {
            var _a, _b;
            var marketoSourceCampaign = (_b = (_a = document
                .querySelector("body")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-marketo-source-campaign")) !== null && _b !== void 0 ? _b : "";
            if (marketoSourceCampaign) {
                var hiddenInput = _this.rootElement.querySelector('input[type="hidden"][value="SOURCECAMPAIGN"]');
                if (hiddenInput != null) {
                    hiddenInput.value = marketoSourceCampaign;
                }
            }
        };
        _this.cookieConsent = function () {
            var cookieBanner = document.getElementById("onetrust-consent-sdk");
            if (cookieBanner != null) {
                var allButtons = cookieBanner.getElementsByTagName("button");
                for (var i = 0; i < allButtons.length; i++) {
                    allButtons[i].onclick = function () { return _this.refreshPage(); };
                }
            }
        };
        _this.refreshPage = function () {
            location.reload();
        };
        _this.styleButtons = function () {
            var buttons = _this.rootElement.querySelectorAll(".Form__MainBody .FormSubmitButton");
            buttons.forEach(function (button) {
                if (button.innerHTML.length > 30) {
                    button.classList.add("long-text");
                }
            });
        };
        _this.renderCustomSelect = function () {
            var selects = _this.rootElement.querySelectorAll(".Form__MainBody select");
            var customSelectIdTracker = 0;
            selects.forEach(function (select) {
                var _a, _b;
                var selectOptions = select.querySelectorAll("option:not([disabled='disabled'])");
                var data = {
                    selectTitle: (_b = (_a = select.querySelector("option[disabled='disabled']")) === null || _a === void 0 ? void 0 : _a.innerText) !== null && _b !== void 0 ? _b : "",
                    selectMultiple: false,
                    selectedString: "",
                    selectOptions: [],
                };
                if (select.hasAttribute("multiple")) {
                    data.selectMultiple = true;
                }
                selectOptions.forEach(function (selectOption) {
                    var selectOptionValue = selectOption.value;
                    var selectOptionText = selectOption.innerText;
                    var isSelected = selectOption.selected;
                    if (selectOption.selected) {
                        if (data.selectedString === "") {
                            data.selectedString = selectOptionText;
                        }
                        else {
                            data.selectedString += ", ".concat(selectOptionText);
                        }
                    }
                    var obj = {
                        optionValue: selectOptionValue,
                        optionText: selectOptionText,
                        isSelected: isSelected,
                    };
                    if (!selectOption.disabled) {
                        data.selectOptions.push(obj);
                    }
                });
                var formSelectWrapperNode = document.createElement("div");
                formSelectWrapperNode.classList.add("form-select");
                formSelectWrapperNode.setAttribute("tabindex", "0");
                formSelectWrapperNode.setAttribute("role", "listbox");
                formSelectWrapperNode.setAttribute("aria-controls", "custom-select-".concat(customSelectIdTracker));
                formSelectWrapperNode.setAttribute("aria-expanded", "false");
                select.insertAdjacentElement("beforebegin", formSelectWrapperNode);
                formSelectWrapperNode.innerHTML = (0, FormSelect_hbs_1.default)(data);
                _this.toggleCustomSelect(formSelectWrapperNode);
                _this.handleOptionSelect(formSelectWrapperNode, data.selectMultiple);
                customSelectIdTracker++;
            });
        };
        _this.toggleCustomSelect = function (select) {
            var selectHeader = select.querySelector(".form-header");
            select.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggle();
                    listTabEnable();
                }
            });
            selectHeader.addEventListener("click", function () {
                toggle();
            });
            function listTabEnable() {
                select.querySelectorAll(".form-list li").forEach(function (item) {
                    item.setAttribute("tabindex", "0");
                    var target = item;
                    target.addEventListener("keydown", function (event) {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            this.click();
                            toggle();
                        }
                    });
                });
            }
            function removeTabIndex() {
                setTimeout(function () {
                    select.querySelectorAll(".form-list li").forEach(function (item) {
                        item.removeAttribute("tabindex");
                    });
                }, 100);
            }
            function toggle() {
                select.classList.toggle("expanded");
                var isDesktop = document.documentElement.clientWidth > 800;
                var threshold = isDesktop ? 300 : 220;
                var isAboveThreshold = document.documentElement.clientHeight -
                    selectHeader.getBoundingClientRect().bottom <
                    threshold;
                if (isAboveThreshold) {
                    select.classList.add("above");
                }
                else {
                    select.classList.remove("above");
                }
                if (!select.classList.value.includes("expanded")) {
                    removeTabIndex();
                }
            }
        };
        _this.nativeSelects = function () {
            var selects = _this.rootElement.querySelectorAll(".Form__MainBody select");
            selects.forEach(function (select) {
                select.addEventListener("change", function () {
                    if (document.documentElement.clientWidth < 800) {
                        var parentElement = select.parentElement;
                        if (!parentElement)
                            return;
                        var element = parentElement.querySelector("li[data-value='".concat(select.value, "']"));
                        if (select.hasAttribute("multiple")) {
                            if (element) {
                                element.click();
                            }
                            else {
                                var formHeaderSpan = parentElement.querySelector(".form-header span");
                                if (formHeaderSpan) {
                                    formHeaderSpan.innerHTML = select.options[0].innerHTML;
                                }
                            }
                        }
                        else if (select.value !== "") {
                            if (element) {
                                element.click();
                            }
                        }
                    }
                });
            });
        };
        _this.decodeHTMLEntities = function (str) {
            var textarea = document.createElement("textarea");
            textarea.innerHTML = str;
            return textarea.value;
        };
        _this.handleOptionSelect = function (select, isMultiple) {
            var _a;
            var originalSelect = select.nextElementSibling;
            if (isMultiple) {
                var options = select.querySelectorAll("li[data-type='js-multi-select']");
                options.forEach(function (option) {
                    option.addEventListener("click", function (e) {
                        var target = e.target;
                        target.classList.toggle("selected");
                        setOptionState();
                        originalSelect === null || originalSelect === void 0 ? void 0 : originalSelect.dispatchEvent(new Event("change"));
                    });
                });
                setOptionState();
            }
            else {
                var selectTitleElement_1 = select.querySelector(".form-header span");
                var originalSelectOptions_1 = (_a = select.nextElementSibling) === null || _a === void 0 ? void 0 : _a.querySelectorAll("option:not([disabled='disabled'])");
                var options = select.querySelectorAll("li[data-type='js-single-select']");
                options.forEach(function (option) {
                    option.addEventListener("click", function (e) {
                        var _a, _b;
                        var target = e.target;
                        var previousSelectedItem = select.querySelector(".selected");
                        select.classList.add("has-selection");
                        if (previousSelectedItem !== null) {
                            previousSelectedItem.classList.remove("selected");
                        }
                        target.classList.add("selected");
                        var decodedValue = _this.decodeHTMLEntities((_b = (_a = target.querySelector("span")) === null || _a === void 0 ? void 0 : _a.innerHTML) !== null && _b !== void 0 ? _b : "");
                        if (selectTitleElement_1) {
                            selectTitleElement_1.innerText = decodedValue;
                        }
                        select.classList.remove("expanded");
                        if (document.documentElement.clientWidth > 800) {
                            originalSelectOptions_1 === null || originalSelectOptions_1 === void 0 ? void 0 : originalSelectOptions_1.forEach(function (selectOption) {
                                var option = selectOption;
                                if (target.dataset.value === option.value) {
                                    option.selected = true;
                                }
                                else {
                                    option.selected = false;
                                }
                            });
                            originalSelect === null || originalSelect === void 0 ? void 0 : originalSelect.dispatchEvent(new Event("change"));
                        }
                    });
                });
            }
            function setOptionState() {
                var _a, _b, _c, _d;
                var selectedItems = select.querySelectorAll(".selected");
                var originalSelectOptions = (_a = select.nextElementSibling) === null || _a === void 0 ? void 0 : _a.querySelectorAll("option:not([disabled='disabled'])");
                var selectTitleElement = select.querySelector(".form-header span");
                var selectTitle = (_b = selectTitleElement === null || selectTitleElement === void 0 ? void 0 : selectTitleElement.getAttribute("data-title")) !== null && _b !== void 0 ? _b : "";
                if (document.documentElement.clientWidth > 800) {
                    originalSelectOptions.forEach(function (originalSelectOption) {
                        originalSelectOption.selected = false;
                    });
                    selectedItems.forEach(function (selectedItem) {
                        var selectedItemElement = selectedItem;
                        originalSelectOptions.forEach(function (originalSelectOption) {
                            if (selectedItemElement.dataset.value ===
                                originalSelectOption.value) {
                                originalSelectOption.selected = true;
                            }
                        });
                    });
                }
                if (selectedItems.length === 0) {
                    if (selectTitleElement) {
                        selectTitleElement.innerHTML = selectTitle;
                    }
                    select.classList.remove("has-selection");
                }
                else if (selectedItems.length === 1) {
                    if (selectTitleElement) {
                        selectTitleElement.innerHTML =
                            (_d = (_c = selectedItems[0].querySelector(".textbox")) === null || _c === void 0 ? void 0 : _c.innerHTML) !== null && _d !== void 0 ? _d : "";
                    }
                    select.classList.add("has-selection");
                }
                else {
                    selectedItems.forEach(function (selectedItem, index) {
                        var _a, _b, _c, _d;
                        if (index === 0) {
                            if (selectTitleElement) {
                                selectTitleElement.innerHTML =
                                    (_b = (_a = selectedItem.querySelector(".textbox")) === null || _a === void 0 ? void 0 : _a.innerHTML) !== null && _b !== void 0 ? _b : "";
                            }
                        }
                        else {
                            if (selectTitleElement) {
                                selectTitleElement.innerHTML += ", ".concat((_d = (_c = selectedItem.querySelector(".textbox")) === null || _c === void 0 ? void 0 : _c.innerHTML) !== null && _d !== void 0 ? _d : "");
                            }
                        }
                    });
                    select.classList.add("has-selection");
                }
                if (document.documentElement.clientWidth < 800) {
                    var selectedOptions = Array.from(originalSelectOptions)
                        .filter(function (option) { return option.selected; })
                        .map(function (option) { return option.innerHTML; });
                    if (selectTitleElement) {
                        selectTitleElement.innerHTML = selectedOptions.join(", ");
                    }
                }
            }
        };
        return _this;
    }
    FormBlock.prototype.init = function () {
        this.styleButtons();
        this.renderCustomSelect();
        this.nativeSelects();
        this.copyMarketoSourceCampaign();
        var utmParams = utm_1.default.getUtmTagsFromUrlOrCookie();
        this.addUTMValuesToHiddenInputs(utmParams);
    };
    return FormBlock;
}(Block_1.Block));
exports.FormBlock = FormBlock;
Initializer_1.Initializer.initBlock(".js-form-block", FormBlock);
